module.exports = __webpack_public_path__ + "img/product_dietz_xc.d9ca6436.jpg";